module.exports = __webpack_public_path__ + "img/about-3.1cbbd39a.png";